import { render } from "./Adresses.vue?vue&type=template&id=5f835a38"
import script from "./Adresses.vue?vue&type=script&lang=ts"
export * from "./Adresses.vue?vue&type=script&lang=ts"
script.render = render

export default script